import { getTicketApi } from 'app/services/checkTicketApi';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { GET_LIST_PAYMENT_METHOD, GET_LIST_TICKET_FORM, GET_TICKETS } from '.';
import { getPaymentMethodApi } from 'app/services/checkoutApi';
import { commonActions } from 'utils/hooks/useReduceCommon';

export function* getTickets({ payload }: any) {
  const { _params, onSuccess } = payload;
  try {
    yield put(commonActions.fetchLoadingPage());
    const { data } = yield call(getTicketApi, _params);
    yield put(
      GET_TICKETS.success({
        tickets: data.data,
        paginator: data.paginator,
        maxFileReleaseTicket: data.maxFileReleaseTicket,
      }),
    );
    onSuccess?.();
  } catch (err) {
    yield put(GET_TICKETS.failure());
  } finally {
    yield put(commonActions.fetchHiddenLoadingPage());
  }
}
export function* getOptionShows({ payload }: any) {
  try {
    const { data } = yield call(getTicketApi, payload);

    yield put(
      GET_TICKETS.success({ tickets: data.data, paginator: data.paginator }),
    );
  } catch (err) {
    yield put(GET_TICKETS.failure());
  }
}

export function* getListPaymentMethod({ payload }: any) {
  try {
    const { data } = yield call(getPaymentMethodApi, payload);
    yield put(GET_LIST_PAYMENT_METHOD.success(data.data));
    yield put(GET_LIST_TICKET_FORM.success(data?.dataDeliverTicketType || []));
  } catch (err) {
    yield put(GET_LIST_PAYMENT_METHOD.failure());
  }
}

export function* checkTicketSaga() {
  yield takeLatest(GET_TICKETS.TRIGGER, getTickets);
}
